<template>
  <div>
    <div v-if="user" id="snpswap">
      <nav class="navbar sticky-top navbar-light bg-light">
        <div class="navbar-brand text-truncate">
          <!-- Placeholder for user profile-->
          <button
            type="button"
            class="btn btn-outline-danger ml-1"
            data-toggle="modal"
            data-target="#userProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="id-badge" />
          </button>
          <button
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#infoProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="info" />
          </button>
          <span class="h4 text-success text-capitalize ml-2"
            >{{ selectedTypeName }} System</span
          >
        </div>
        <div class="navbar-text ml-auto d-flex">
          <!-- Project profile button -->
          <button
            v-if="selectedProject"
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#projectProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="project-diagram" />
          </button>

          <div v-if="selectedCart">
            <button
              type="button"
              class="btn btn-outline-success ml-1"
              data-toggle="modal"
              data-target="#cartProfile"
              data-backdrop="static"
              data-keyboard="false"
            >
              <span v-if="!cartIsFull" class="badge badge-pill badge-light">{{
                cartQty
              }}</span>
              <span v-if="cartIsFull" class="badge badge-pill badge-danger">{{
                cartQty
              }}</span>
              <font-awesome-icon icon="shopping-cart" />
            </button>
          </div>
        </div>
        <!-- .navbar-text ml-auto d-flex -->
      </nav>
      <!-- sticky top -->

      <!-- userProfile -->
      <OlabUserProfile :user="user" />

      <!-- infoProfile -->
      <OlabInfoProfile
        :user="user"
        :selectedTypeName="selectedTypeName"
        :cstComp="snpComp"
      />

      <!-- projectProfile -->
      <OlabProjectProfile :user="user" :project="selectedProject" />

      <!-- cartProfile -->
      <OlabCartProfile
        :user="user"
        :selectedProject="selectedProject"
        :selectedCart="selectedCart"
      />
      <article
        v-if="selectedCart"
        class="page-snpswap text-center py-3"
        id="page-snpswap"
      >
        <header class="page-snpswap-header container mb-2">
          <div class="row justify-content-center">
            <div class="col-11">
              <h3>Single Nucleotide Polymorphism Swap</h3>
              <!-- <div>
                <h3 class="text-warning my-3">
                  <font-awesome-icon
                    class="mx-2 text-success"
                    icon="seedling"
                  ></font-awesome-icon>
                  Work in progress ...
                  <font-awesome-icon
                    class="mx-2 text-success"
                    icon="seedling"
                  ></font-awesome-icon>
                </h3>
              </div> -->
              <div class="container text-center">
                <div class="my-2 text-danger">
                  SNP Swap is only applicable for cart's items selected from
                  genome database
                </div>
                <button
                  v-if="entered == false"
                  type="button"
                  class="btn btn-info"
                  v-on:click="loadGenesFromCart()"
                >
                  Enter
                </button>
                <div
                  v-if="entered === true && snpComps.length == 0"
                  class="alert alert-warning"
                  role="alert"
                >
                  No gene from genome database found in cart!
                  <p class="pt-2 h5">
                    <span>Please select a different cart from the</span>
                    <span>
                      <router-link to="/compdb" v-if="user">
                        Component
                      </router-link>
                    </span>
                    <span>module.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section>
          <SNPSwapList
            v-if="user"
            :user="user"
            :dbInfo="dbInfo"
            :snpSwaps="snpComps"
            :error="error"
            :selectedCart="selectedCart"
          />
        </section>
      </article>
      <article v-else class="page-snpswap text-center py-5" id="page-snpswap">
        <header class="page-snpswap-header container">
          <p class="h3">SNPSwap Module requires a selected Cart to proceed.</p>
          <p class="h5">
            <span>Please select a cart from the</span>
            <span>
              <router-link to="/compdb" v-if="user"> Component </router-link>
            </span>
            <span>module.</span>
          </p>
        </header>
      </article>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SNPSwapList from "@/components/SNPSwapList";
import OlabUserProfile from "@/components/OlabUserProfile";
import OlabInfoProfile from "@/components/OlabInfoProfile";
import OlabProjectProfile from "@/components/OlabProjectProfile";
import OlabCartProfile from "@/components/OlabCartProfile";
import { OlabComp } from "../olab/olabcomp.js";
import { OlabSNPSwap } from "../olab/olabsnpswap.js";
// import { OlabBlock } from "../olab/olabblock.js";
import { OlabUtils } from "../olab/olabutils.js";
// import firebase from "firebase";
// import db from "../olab/db.js";
// import $ from "jquery";
// import _ from "lodash";

export default {
  name: "snpswap",
  data: function() {
    return {
      cartItems: null,
      snpComps: [],
      snpComp: null,
      selectedTypeName: "SNP Swap",
      entered: false
    };
  },
  components: {
    FontAwesomeIcon,
    SNPSwapList,
    OlabUserProfile,
    OlabInfoProfile,
    OlabProjectProfile,
    OlabCartProfile
  },
  props: [
    "user",
    "dbInfo",
    "selectedProject",
    "selectedCart",
    "selectedPackage",
    "error"
  ],
  mounted: function() {
    OlabUtils.infoLog("SNPSwap mounted ...");
    if (this.selectedCart) {
      OlabUtils.infoLog(" - selectedCart = " + this.selectedCart.olab_id);
      // Load items from cart
      this.initComps();
    } else {
      // selectedCart will be null temporarily when a user reload page
      // This reloadWorkaround is an attempt to catch such a situation
      OlabUtils.infoLog("selectedCart is null");
      this.reloadWorkaround();
    }
  },
  watch: {},
  computed: {
    cartQty: function() {
      let qty = 0;
      if (this.selectedCart != null && this.selectedCart.comps != null) {
        for (let idx in this.selectedCart.comps) {
          qty = qty + this.selectedCart.comps[idx].qty;
        }
      }
      return qty;
    },
    cartIsFull: function() {
      // Limit to 10 items per cart
      return this.cartQty > 9 ? true : false;
    }
  },
  methods: {
    delayInSecond: function(sec) {
      return new Promise(resolve => setTimeout(resolve, sec * 1000));
    },
    reloadWorkaround: async function() {
      OlabUtils.infoLog("reloadWorkaround: zero seconds");
      this.counter = 0;
      await this.delayInSecond(3);
      OlabUtils.infoLog("reloadWorkaround: two seconds");
      if (this.selectedCart) {
        // FIX ME: push to Home to reset states for now
        this.$router.push("/");
      }
    },
    initComps: function() {
      OlabUtils.infoLog("initComps ...");
      // Only do this once when cartItems is null
      if (this.cartItems === null) {
        if (this.selectedCart && this.selectedCart.comps) {
          const ccArr = [];
          const comps = this.selectedCart.comps;
          for (let i = 0; i < comps.length; i++) {
            const cp = comps[i];
            const cc = new OlabComp(cp);
            ccArr.push(cc);
          }
          this.cartItems = ccArr;
          OlabUtils.infoLog("cartItems.length = " + this.cartItems.length);
        }
      } else {
        OlabUtils.infoLog(
          "Nothing done. CartItems was initialized. : length = " +
            this.cartItems.length
        );
      }
    },
    loadGenesFromCart() {
      OlabUtils.infoLog("loadGenesFromCart ...");
      if (this.cartItems != null) {
        const snpArr = [];
        for (let i = 0; i < this.cartItems.length; i++) {
          const cp = this.cartItems[i];
          if (cp.comp.olab_type == "strain") {
            const snp = new OlabSNPSwap(cp.seq);
            snpArr.push(snp);
          } else {
            OlabUtils.infoLog(
              "Not strain: cp.comp.olab_type = " + cp.comp.olab_type
            );
          }
        }
        this.snpComps = snpArr;
        OlabUtils.infoLog(
          "loadGenesFromCart: snpComps.length = " + this.snpComps.length
        );
        this.entered = true;
      }
    }
  }
};
</script>
<style lang="scss">
.page-snpswap {
  background-color: rgb(240, 250, 226);
}
</style>
